import { FormControl, FormLabel, Input } from "@mui/joy";
import React, { useEffect, useRef, useState } from "react";
import { Accordion, Button, Form } from "react-bootstrap";
import { connect, useSelector } from "react-redux";
import {
  create_faq_question,
  get_blog_spotlight_content,
  upload_cms_photo,
} from "../../reduxData/cms/cmsAction";
import { useDispatch } from "react-redux";

const BlogSpotlightContent = ({ blogSpotlightContent }) => {
  const { user } = useSelector((state) => state.auth);
  const [isPermission, setIsPermission] = useState(false);
  const [isPermissionDelete, setIsPermissionDelete] = useState(false);

  useEffect(() => {
    setIsPermission(
      (user?.role === "staff" && user?.permission?.p_staff > 1) ||
        user?.role !== "staff"
        ? true
        : false
    );
    setIsPermissionDelete(
      (user?.role === "staff" && user?.permission?.p_staff > 2) ||
        user?.role !== "staff"
        ? true
        : false
    );
  }, [user]);

  const [formData, setFormData] = useState({
    mainCard: {
      category: "",
      title: "",
      description: "",
      image: "",
      link: "",
    },
    secondaryCards: [
      {
        category: "",
        title: "",
        description: "",
        image: "",
        link: "",
      },
      {
        category: "",
        title: "",
        description: "",
        image: "",
        link: "",
      },
    ],
    status: false,
  });

  const [errors, setErrors] = useState({
    mainCard: {
      category: "",
      title: "",
      description: "",
      image: "",
      link: "",
    },
    secondaryCards: [
      {
        category: "",
        title: "",
        description: "",
        image: "",
        link: "",
      },
      {
        category: "",
        title: "",
        description: "",
        image: "",
        link: "",
      },
    ],
  });

  const dispatch = useDispatch();

  // Refs for image uploads
  const mainImageRef = useRef();
  const secondary1ImageRef = useRef();
  const secondary2ImageRef = useRef();

  const handleImageClick = (cardType, index = null) => {
    if (cardType === "main") {
      mainImageRef.current.click();
    } else if (cardType === "secondary") {
      if (index === 0) {
        secondary1ImageRef.current.click();
      } else {
        secondary2ImageRef.current.click();
      }
    }
  };

  const handleImage = async (e, cardType, index = null) => {
    const imageUpload = [e.target.files[0]];
    const photoData = await upload_cms_photo(
      imageUpload,
      localStorage.getItem("token"),
      dispatch
    );

    if (cardType === "main") {
      setErrors({
        ...errors,
        mainCard: { ...errors.mainCard, image: "" },
      });
      setFormData({
        ...formData,
        mainCard: {
          ...formData.mainCard,
          image: photoData?.data?.photos[0],
        },
      });
    } else if (cardType === "secondary") {
      const newSecondaryCards = [...formData.secondaryCards];
      newSecondaryCards[index] = {
        ...newSecondaryCards[index],
        image: photoData?.data?.photos[0],
      };

      const newSecondaryErrors = [...errors.secondaryCards];
      newSecondaryErrors[index] = {
        ...newSecondaryErrors[index],
        image: "",
      };

      setErrors({
        ...errors,
        secondaryCards: newSecondaryErrors,
      });
      setFormData({
        ...formData,
        secondaryCards: newSecondaryCards,
      });
    }
  };

  const handleMainCardChange = (field, value) => {
    setFormData({
      ...formData,
      mainCard: {
        ...formData.mainCard,
        [field]: value,
      },
    });
  };

  const handleSecondaryCardChange = (index, field, value) => {
    const newSecondaryCards = [...formData.secondaryCards];
    newSecondaryCards[index] = {
      ...newSecondaryCards[index],
      [field]: value,
    };
    setFormData({
      ...formData,
      secondaryCards: newSecondaryCards,
    });
  };

  const handleStatusChange = (checked) => {
    setFormData({
      ...formData,
      status: checked,
    });
  };

  const handleRemoveImage = (cardType, index = null) => {
    if (cardType === "main") {
      setFormData({
        ...formData,
        mainCard: {
          ...formData.mainCard,
          image: "",
        },
      });
    } else if (cardType === "secondary") {
      const newSecondaryCards = [...formData.secondaryCards];
      newSecondaryCards[index] = {
        ...newSecondaryCards[index],
        image: "",
      };
      setFormData({
        ...formData,
        secondaryCards: newSecondaryCards,
      });
    }
  };

  const handleErrors = () => {
    const newErrors = {
      mainCard: {
        category: "",
        title: "",
        description: "",
        image: "",
        link: "",
      },
      secondaryCards: [
        {
          category: "",
          title: "",
          description: "",
          image: "",
          link: "",
        },
        {
          category: "",
          title: "",
          description: "",
          image: "",
          link: "",
        },
      ],
    };

    let hasErrors = false;

    // Validate main card
    if (!formData.mainCard.category) {
      newErrors.mainCard.category = "Category is required";
      hasErrors = true;
    }
    if (!formData.mainCard.title) {
      newErrors.mainCard.title = "Title is required";
      hasErrors = true;
    }
    if (!formData.mainCard.description) {
      newErrors.mainCard.description = "Description is required";
      hasErrors = true;
    }
    if (!formData.mainCard.image) {
      newErrors.mainCard.image = "Image is required";
      hasErrors = true;
    }
    if (!formData.mainCard.link) {
      newErrors.mainCard.link = "Link is required";
      hasErrors = true;
    }

    // Validate secondary cards
    formData.secondaryCards.forEach((card, index) => {
      if (!card.category) {
        newErrors.secondaryCards[index].category = "Category is required";
        hasErrors = true;
      }
      if (!card.title) {
        newErrors.secondaryCards[index].title = "Title is required";
        hasErrors = true;
      }
      if (!card.description) {
        newErrors.secondaryCards[index].description = "Description is required";
        hasErrors = true;
      }
      if (!card.image) {
        newErrors.secondaryCards[index].image = "Image is required";
        hasErrors = true;
      }
      if (!card.link) {
        newErrors.secondaryCards[index].link = "Link is required";
        hasErrors = true;
      }
    });

    setErrors(newErrors);
    return hasErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const hasErrors = handleErrors();
    if (hasErrors) return;

    const content_data = {
      name: "blog_spotlight_content",
      type: "blog_spotlight_content",
      status: formData?.status,
      content: {
        mainCard: formData.mainCard,
        secondaryCards: formData.secondaryCards,
      },
    };

    await create_faq_question(
      localStorage.getItem("token"),
      content_data,
      blogSpotlightContent[0]?._id,
      dispatch
    );
  };

  useEffect(() => {
    const handleQuest = async () => {
      await get_blog_spotlight_content(
        localStorage.getItem("token"),
        "blog_spotlight_content",
        dispatch
      );
    };
    handleQuest();
  }, []);

  useEffect(() => {
    if (blogSpotlightContent?.length > 0) {
      setFormData((prev) => ({
        ...prev,
        ...blogSpotlightContent[0]?.content,
        status: blogSpotlightContent[0]?.status,
      }));
    }
  }, [blogSpotlightContent]);

  const renderCardSection = (card, cardType, index = null, title) => (
    <Accordion.Item eventKey={cardType === "main" ? "0" : `${index + 1}`}>
      <Accordion.Header>
        <h4 className="mb-0 fw-bold">{title}</h4>
      </Accordion.Header>
      <Accordion.Body>
        <div className="row">
          <FormControl className="mt-2 mb-2 col-md-6">
            <FormLabel className="fw-600">Category</FormLabel>
            <Input
              type="text"
              placeholder="Enter category"
              value={card?.category || ""}
              disabled={!isPermission}
              onChange={(e) =>
                cardType === "main"
                  ? handleMainCardChange("category", e.target.value)
                  : handleSecondaryCardChange(index, "category", e.target.value)
              }
            />
            {((cardType === "main" && errors?.mainCard?.category) ||
              (cardType === "secondary" &&
                errors?.secondaryCards?.[index]?.category)) && (
              <div className="error_msg">
                {cardType === "main"
                  ? errors?.mainCard?.category
                  : errors?.secondaryCards?.[index]?.category}
              </div>
            )}
          </FormControl>

          <FormControl className="mt-2 mb-2 col-md-6">
            <FormLabel className="fw-600">Title</FormLabel>
            <Input
              type="text"
              placeholder="Enter title"
              value={card?.title || ""}
              disabled={!isPermission}
              onChange={(e) =>
                cardType === "main"
                  ? handleMainCardChange("title", e.target.value)
                  : handleSecondaryCardChange(index, "title", e.target.value)
              }
            />
            {((cardType === "main" && errors?.mainCard?.title) ||
              (cardType === "secondary" &&
                errors?.secondaryCards?.[index]?.title)) && (
              <div className="error_msg">
                {cardType === "main"
                  ? errors?.mainCard?.title
                  : errors?.secondaryCards?.[index]?.title}
              </div>
            )}
          </FormControl>

          <FormControl className="mt-2 mb-2 col-md-12">
            <FormLabel className="fw-600">Description</FormLabel>
            <Input
              type="text"
              placeholder="Enter description"
              value={card?.description || ""}
              disabled={!isPermission}
              onChange={(e) =>
                cardType === "main"
                  ? handleMainCardChange("description", e.target.value)
                  : handleSecondaryCardChange(
                      index,
                      "description",
                      e.target.value
                    )
              }
            />
            {((cardType === "main" && errors?.mainCard?.description) ||
              (cardType === "secondary" &&
                errors?.secondaryCards?.[index]?.description)) && (
              <div className="error_msg">
                {cardType === "main"
                  ? errors?.mainCard?.description
                  : errors?.secondaryCards?.[index]?.description}
              </div>
            )}
          </FormControl>

          <FormControl className="mt-2 mb-2 col-md-6">
            <FormLabel className="fw-600">Link</FormLabel>
            <Input
              type="text"
              placeholder="Enter link"
              value={card?.link || ""}
              disabled={!isPermission}
              onChange={(e) =>
                cardType === "main"
                  ? handleMainCardChange("link", e.target.value)
                  : handleSecondaryCardChange(index, "link", e.target.value)
              }
            />
            {((cardType === "main" && errors?.mainCard?.link) ||
              (cardType === "secondary" &&
                errors?.secondaryCards?.[index]?.link)) && (
              <div className="error_msg">
                {cardType === "main"
                  ? errors?.mainCard?.link
                  : errors?.secondaryCards?.[index]?.link}
              </div>
            )}
          </FormControl>

          <FormControl className="mt-2 mb-2 col-md-6">
            <FormLabel className="fw-600">Image</FormLabel>
            {card?.image && (
              <div className="position-relative pb-3 d-flex h-100">
                <img
                  src={card?.image}
                  style={{
                    height: "200px",
                    width: "50%",
                  }}
                  alt="img not found"
                />
                {isPermissionDelete && (
                  <div className="position-absolute upload-file-close">
                    <button
                      type="button"
                      className="btn btn-sm rounded-circle"
                      onClick={() => handleRemoveImage(cardType, index)}
                    >
                      <i className="fa-solid fa-xmark color-white"></i>
                    </button>
                  </div>
                )}
              </div>
            )}
            <input
              type="file"
              className="d-none"
              accept="image/png, image/jpg, image/jpeg, image/gif"
              ref={
                cardType === "main"
                  ? mainImageRef
                  : index === 0
                  ? secondary1ImageRef
                  : secondary2ImageRef
              }
              disabled={!isPermission}
              onChange={(e) => {
                handleImage(e, cardType, index);
                e.target.value = "";
              }}
            />
            <Button
              className="btn upload-button"
              disabled={!isPermission}
              onClick={() => handleImageClick(cardType, index)}
            >
              Upload
            </Button>
            {((cardType === "main" && errors?.mainCard?.image) ||
              (cardType === "secondary" &&
                errors?.secondaryCards?.[index]?.image)) && (
              <div className="error_msg">
                {cardType === "main"
                  ? errors?.mainCard?.image
                  : errors?.secondaryCards?.[index]?.image}
              </div>
            )}
          </FormControl>
        </div>
      </Accordion.Body>
    </Accordion.Item>
  );

  return (
    <div className="container">
      <Form onSubmit={handleSubmit}>
        <Accordion defaultActiveKey={["0"]} alwaysOpen>
          {renderCardSection(formData.mainCard, "main", null, "Main Card")}
          {formData.secondaryCards.map((card, index) =>
            renderCardSection(
              card,
              "secondary",
              index,
              `Secondary Card ${index + 1}`
            )
          )}
        </Accordion>

        <FormControl className="mt-2 mb-2 ms-2">
          <FormLabel className="fw-600">Status</FormLabel>
          <div className="form-check form-switch switch-large">
            <input
              className="form-check-input"
              type="checkbox"
              name="status"
              role="switch"
              id="flexSwitchCheckDefault"
              checked={formData.status}
              disabled={!isPermission}
              onChange={(e) => handleStatusChange(e.target.checked)}
            />
          </div>
        </FormControl>

        <Button
          type="submit"
          className="btn common-button"
          disabled={!isPermission}
        >
          Save
        </Button>
      </Form>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    blogSpotlightContent: state.cms.blogSpotlightContent,
  };
};

export default connect(mapStateToProps)(BlogSpotlightContent);
